module.exports = __webpack_public_path__ + "roundabout_slight_right.svg?f10dcdef491f32ecf537aa70f826e02b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_slight_right.svg
// module id = 221
// module chunks = 0